module.exports = __webpack_public_path__ + "img/lupin.30147b37.svg";